<div class="calendar-drop">
    <div class="calendar-right-header">
        <div class="crh-left">{{bs.getResource('rbkey_MyTsksLBL') | uppercase}} ({{TaskCount}})</div>
        <div class="crh-right">{{CurrentDate}}</div>
    </div>
    <app-loader *ngIf="loader"></app-loader>
    <div class="cr-inner" *ngIf="!loader">
        <div class="cr-in-box" *ngFor="let item of MyTask">
            <div class="cr-inn-top">
                <div class="cr-in-heading pointer" [innerHtml]="item['CourseName']" (click)="openLearningItem(item['ILTID'],item['CourseType'])"></div>
                <div class="cr-in-subheading">{{item['CourseTypeName']}}, {{item['LearningFlag']}}</div>
            </div>
            <div class="cr-inn-bottom">
                <div class="progress-bar-div">
                    <div class="pro-date">
                        <span>{{(item.HasExpired==1 && item.ExpiryDay !="-")?bs.getResource('rbkey_ExprdnLBL') : bs.getResource('rbkey_ExprsOnLBL_App') }}</span> {{item['ExpiryDay']}}
                        {{item['ExpiryMonth']}} {{item['ExpiryYear']}}</div>
                    <div class="pro-detail">
                        <div class="left">{{item['Status']}}</div>
                        <div class="right">{{item['Progress']}}%</div>
                    </div>
                    <div class="pro-bar-custom">
                        <div class="pro-bar-inn-custom" [style.width]="item['Progress']+'%'"></div>
                    </div>
                </div>
            </div>
        </div>

        <span class="span-no-item" *ngIf="TaskCount == 0">{{bs.getResource('rbkey_NoItmToDsply')}}</span>

    </div>
    <div class="side-overlay box-overlay">
        <div class="inn-text">
            Drag and
            <br> Drop
        </div>
    </div>
</div>